import LoginForm from "../components/LoginForm";
import '../components/Global.css';



function LoginPage() {
    return (
        <div className="container">
            
            <div className="cLeft simpleDiv bc2">
                <div className="inner">
                    <h1 className="header s-margin-bottom1 ">Welcome Back</h1>
                    <h3 className="subHeader s-margin-bottom2">Pleae enter your details</h3>
                    <LoginForm></LoginForm>
                </div>
            </div>

            <div className="cRight simpleDiv">
            </div>
            
        </div>
    )
}

export default LoginPage;